@let ogcFilters = options().ogcFilters;
@if (
  header() &&
  ogcFilters &&
  ogcFilters.enabled &&
  (ogcFilters.pushButtons ||
    ogcFilters.checkboxes ||
    ogcFilters.radioButtons ||
    ogcFilters.select ||
    ogcFilters.autocomplete ||
    ogcFilters.editable)
) {
  <button
    mat-icon-button
    collapsibleButton
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.filter.filterBy' | translate"
    [color]="color()"
  >
    <mat-icon
      aria-hidden="false"
      [matBadge]="badge()"
      matBadgeColor="accent"
      matBadgeSize="medium"
      >filter_alt</mat-icon
    >
  </button>
}

@if (
  ogcFilters &&
  ogcFilters.enabled &&
  (ogcFilters.pushButtons ||
    ogcFilters.checkboxes ||
    ogcFilters.radioButtons ||
    ogcFilters.select ||
    ogcFilters.autocomplete ||
    ogcFilters.editable)
) {
  <div #ogcFilter class="igo-layer-actions-container">
    @if (ogcFilterCollapse && ogcFilters.enabled) {
      <igo-ogc-filterable-item
        igoListItem
        [header]="false"
        [map]="layer().map"
        [layer]="layer()"
      />
    }
  </div>
}
